import ClientAPI from './client.api'

export default ClientAPI
